// extracted by mini-css-extract-plugin
export default {"statistic__table_wrap":"Statistic_statistic__table_wrap__l-JCI","statistic":"Statistic_statistic__k-6xc","statistic__control":"Statistic_statistic__control__AnDP2"};